import { useCallback, useState } from 'react';

import { cx } from '@libs/classnames';
import { CapsuleButton } from '@ui/components/CapsuleButton';
import { useMediaQuery } from '@providers/MediaQueryProvider';
import { SignInIcon } from '@ui/icons/SignInIcon/SignInIcon';

import { UserSettingsProps } from '@features/user/hooks/useUserSettings';
import { UserAuthMenuPopover } from '@features/user/ui/UserAuthMenu/UserAuthMenuPopover';
import { UserAvatar } from '@features/user/ui/UserAvatar/UserAvatar';

import styles from './UserAuthMenu.module.css';

type Props = {
  editProfileLink?: string;
  user?: {
    userId: string;
    firstName: string;
    lastName: string;
  } | null;
  settings?: UserSettingsProps;
  alwaysRound?: boolean;
  onLogin: () => void;
  onLogout: () => void;
};

export function UserAuthMenu({
  user,
  editProfileLink,
  alwaysRound,
  onLogin,
  onLogout,
  settings,
}: Props) {
  const isMobile = useMediaQuery() === 'mobile';
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const handleLogout = useCallback(() => {
    setIsPopoverOpen(false);
    onLogout();
  }, [onLogout, setIsPopoverOpen]);

  return (
    <div className={cx(styles.userMenu, { [styles.is_always_round]: alwaysRound })}>
      {user ? (
        <>
          <UserAvatar
            size={isMobile ? '28' : '32'}
            user={user}
            onClick={() => setIsPopoverOpen(true)}
          />

          <UserAuthMenuPopover
            className={styles.userAuthMenuPopover}
            user={user}
            editProfileLink={editProfileLink}
            settings={settings}
            onClose={() => setIsPopoverOpen(false)}
            isOpen={isPopoverOpen}
            onLogout={handleLogout}
          />
        </>
      ) : (
        <CapsuleButton
          className={styles.signInButton}
          size={isMobile ? '13m-28' : '13m-32'}
          onClick={onLogin}
        >
          <span className={styles.label}>Войти&nbsp;</span>
          <SignInIcon />
        </CapsuleButton>
      )}
    </div>
  );
}
